/** @format */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  svgHover: {
    fill: theme.palette.foreground.default,
    "&:hover": {
      fill: theme.palette.primary.main,
    },
    transition: "all 0.5s ease",
  },
}));

export const Logo = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const AboutMe = useSelector((state) => state.getAboutMe);
  const { loading, error, aboutMe } = AboutMe;

  return (
    <img
      style={{
        width: "50px",
        height: "50px",
      }}
      src={aboutMe?.Picture}
      alt=""
    />
  );
};
